import { eviSearch } from '~/services/serviceInstances';

export interface HandlersByPositionParam {
  position: number;
  query: Array<any>;
  sort: string;
}

export const getHandlersByPosition = ({
  position,
  query,
  sort,
}: HandlersByPositionParam) => {
  return eviSearch.post('/handlers-by-position', {
    data: {
      attributes: {
        position,
        query,
        sort,
      },
    },
  });
};
